<template>
  <div class="rootClass">
    <div>
      <header class="mint-header is-fixed" style="border-bottom: 1px solid gainsboro;background: white">
        <div style="width: 30rem;height: 32px;" class="mint-search searchstyle">
          <div class="mint-searchbar" style="padding: 0">
            <div class="mint-searchbar-inner">
              <i class="mintui mintui-search"/>
              <input type="search" placeholder="请输入国家名称" class="mint-searchbar-core" style="color: black" v-model="searchKey"/>
              <a class="mint-searchbar-cancel" style="display: none;">取消</a>
            </div>
            <div class="mint-search-list" style="display: none;">
              <div class="mint-search-list-warp"/>
            </div>
          </div>
        </div>
        <div style="float: left;">
          <img src="../../../assets/images/32/search.png" @click="SearchCircle"
               style="margin-right:5px ;padding: 0" height="20"
               width="20"
               slot="icon" alt="">
        </div>
      </header>
    </div>
    <div style="margin-top: 50px">
      <IndexBar :index-list="indexList" highlight-color="black" :stick="false">
        <div v-for="item in ContryList" :key="item.name">
          <IndexAnchor :index="item.firstName"> {{ item.name }}</IndexAnchor>
          <div v-for="cell in item.contries" :key="cell.id" class="unitDiv" @click="Details(cell)">
            <div style="float: left">
              <div style="float: left">
                <div style="margin-top: 1.6rem;margin-left: 0.5rem">
                  <img :src="cell.nationalflag" width="40" height="26.7" alt="">
                </div>
                <div>
                  <img src="../../../assets/images/32/left.png"
                       v-show="cell.roadaccess && cell.roadaccess.includes('靠左行驶')"
                       width="16" height="16" alt="">
                  <img src="../../../assets/images/32/right.png"
                       v-show="cell.roadaccess && cell.roadaccess.includes('靠右行驶')" width="16"
                       height="16" alt="">
                  <img src="../../../assets/images/32/drive_left.png"
                       v-show="cell.roadaccess && cell.roadaccess.includes('靠左驾驶')"
                       width="16" height="16" alt="">
                  <img src="../../../assets/images/32/drive_right.png"
                       v-show="cell.roadaccess && cell.roadaccess.includes('靠右驾驶')" width="16"
                       height="16" alt="">
                </div>
              </div>
              <div style="float: left;margin-left: 0.5rem;max-width:82%;text-align: left">
                <div style="display: flex">
                  <Span style="color: #2986de;">{{ cell.name }}</Span>
                </div>
                <div style="display: flex">
                  <Span style="font-size: 0.8rem">全称：{{ cell.cname + '-' + cell.code }}</Span>
                </div>
                <div style="display: flex">
                  <Span style="font-size: 0.8rem">首都：{{ cell.capital }}</Span>
                </div>
                <div style="display: flex">
                  <Span style="font-size: 0.8rem">面积：{{ cell.area }}</Span>
                </div>
                <div style="display: flex">
                  <Span style="font-size: 0.8rem">语言：{{ cell.language }}</Span>
                </div>
                <div style="clear: both">
                </div>
              </div>
              <div style="clear: both"></div>
            </div>
            <div style="clear: both"></div>
          </div>
        </div>
      </IndexBar>
      <Cell :title="'共计：'+ContryLenth()"/>
    </div>
    <div class="empty-div" v-if="showEmptyImage">
      <img src="../../../assets/images/no_data.png" alt=""/>
    </div>
  </div>
</template>

<script>
import {IndexBar, IndexAnchor, Cell} from 'vant';
import 'vant/lib/index-bar/index.css'
import 'vant/lib/index-anchor/index.css'
import 'vant/lib/cell/index.css'
import ContryDetails from "@/components/menu/tools/ContryDetails";
import {Indicator} from "mint-ui";

export default {
  name: "ContryList",
  components: {
    IndexBar, IndexAnchor, Cell
  },
  data() {
    return {
      showEmptyImage: false,
      searchKey: null,
      indexList: ['亚', '欧', '南', '北', '大', '非'],
      continent: {
        contries: [],
        firstName: null,
        name: null,
      },
      contry: ContryDetails.data().contry,
      ContryList: [],
      ContryList_Temp: [],
      token: localStorage.getItem('token'),
      getContryUrl: '/api/otherapi/getContry',
    }
  },
  mounted() {
    this.getContry()
  },
  watch: {
    searchKey: function (val) {
      if (val.toString().length === 0) {
        this.ContryList = this.ContryList_Temp
        this.showEmptyImage = this.ContryList.length <= 0;
      }
    }
  },
  methods: {
    ContryLenth() {
      let result = 0
      for (let i = 0; i < this.ContryList.length; i++) {
        for (let j = 0; j < this.ContryList[i].contries.length; j++) {
          result++
        }
      }
      return result
    },
    SearchCircle() {
      let temp = []
      for (let i = 0; i < this.ContryList_Temp.length; i++) {
        let newContries = null
        let contries = JSON.stringify(this.ContryList_Temp[i])
        newContries = JSON.parse(contries)
        newContries.contries = []
        for (let j = 0; j < this.ContryList_Temp[i].contries.length; j++) {
          if (this.ContryList_Temp[i].contries[j].cname.includes(this.searchKey) || this.ContryList_Temp[i].contries[j].name.includes(this.searchKey)) {
            newContries.contries.push(this.ContryList_Temp[i].contries[j])
          }
        }
        if (newContries.contries.length > 0)
          temp.push(newContries)
      }
      this.ContryList = temp
      this.showEmptyImage = this.ContryList.length <= 0;
    },
    Details(val) {
      this.$router.push({name: 'm_contry_details', params: {contry: val}})
    },
    getContry() {
      Indicator.open({
        text: '数据加载中...',
        spinnerType: 'fading-circle'
      });
      let that = this
      that.$ajax({
        method: 'get',
        url: that.getContryUrl,
        headers: {token: that.token, needToken: 'false'}
      }).then((response) => {
            Indicator.close()
            if (!response.data.result)
              that.$messagebox.alert(response.data.message)
            else {
              that.ContryList = response.data['responseData']
              that.ContryList_Temp = response.data['responseData']
              that.showEmptyImage = that.ContryList.length <= 0;
            }
          }
      ).catch(response => {
        Indicator.close()
        that.$messagebox.alert(response.request.status === 404 ? "服务器连接失败" : "未知错误，请联系服务商" + response, '服务器异常')
      })
    },
  },
}
</script>

<style lang="less" scoped>
.rootClass {
  margin-left: -0.5rem;
  margin-top: -0.5rem;
}

.unitDiv {
  margin: 0.2rem -0.25rem 0.2rem 0.2rem;
  border: 1px solid gray;
  background-color: bisque;
  padding: 0;
}

/deep/ .van-index-bar__index {
  font-size: 20px;
  line-height: 30px;
}

/deep/ .van-index-bar__sidebar {
  margin-right: -0.25rem;
}

/deep/ .van-index-anchor--sticky {
  width: 100% !important;
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  background-color: #fff;
}

.empty-div {
  position: absolute;
  left: 50%;
  top: 40%;
  transform: translate3d(-50%, -50%, 0);
}
</style>
